import { Component, Host, h, Prop, Watch, Element, Method } from '@stencil/core';
import { PulseStyle, Theme } from './types';
export interface AhaProgressSteps extends HTMLAhaProgressStepsElement {}

@Component({
  tag: 'aha-progress-steps',
  styleUrl: 'aha-progress-steps.css',
  shadow: true,
})
export class AhaProgressSteps {
  @Element() host!: HTMLAhaProgressStepsElement;

  /** Whether or not the current step is showing pulsing animation. */
  @Prop({ reflect: true }) pulse: boolean = false;

  /** Style of pulsing animation. */
  @Prop({ reflect: true, attribute: 'pulse-style' }) pulseStyle!: PulseStyle;

  /** Style of progress steps. */
  @Prop({ reflect: true }) theme: Theme = 'standard';

  /** The current step in the progression. Note, you can also set the "current" attribute on any individual step and it will automatically set this value. */
  @Prop({ reflect: true }) step: number = 1;
  @Watch('step')
  private setCurrentStep() {
    this.steps.forEach((stepElem: any, i: number) => {
      stepElem.current = this.step === i + 1;
    });
  }

  get steps() {
    return Array.from(this.host.querySelectorAll(':scope aha-progress-step'));
  }

  /** Get the index of the specified step. */
  @Method()
  async getStepIndex(stepElement: HTMLAhaProgressStepElement) {
    return this.steps.indexOf(stepElement);
  }

  /** Force all numbers in the list to recalculate their positions. Useful for when steps are added/removed from the list. */
  @Method()
  async renumberSteps() {
    this.steps.forEach((stepElem: any, i: number) => {
      stepElem.number = i + 1;
    });
  }

  private handleSlotChange(event: any) {
    const host = event.target.getRootNode().host;
    host.renumberSteps();
    host.setCurrentStep();
  }

  render() {
    return (
      <Host>
        <slot onSlotchange={this.handleSlotChange}></slot>
      </Host>
    );
  }
}
